var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'input-container': true,
    active: _vm.isFocused,
    'disabled-style': _vm.disabledStyle,
  }},[_c('div',{staticClass:"input-row",class:{
      focused: _vm.isFocused,
      error: _vm.error,
      disabled: _vm.disabledState || _vm.disabled,
      'not-empty': _vm.value || _vm.isFocused,
      'disabled-style': _vm.disabledStyle,
    },attrs:{"tabindex":"1"},on:{"mouseup":_vm.onFocusClick}},[_c('div',{staticClass:"input-field",class:{
        focused: _vm.isFocused,
        error: _vm.error,
        'not-empty': _vm.value || _vm.isFocused,
      }},[(_vm.label)?_c('label',{directives:[{name:"html-safe",rawName:"v-html-safe",value:(_vm.label),expression:"label"}],staticClass:"input-label",class:{
          active: _vm.isFocused || _vm.value,
          error: _vm.error,
          disabled: _vm.disabledState || _vm.disabled,
          'disabled-style': _vm.disabledStyle,
        },attrs:{"for":_vm.id}}):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.isCustomPhoneMask ? '' : _vm.inputMask),expression:"isCustomPhoneMask ? '' : inputMask"}],ref:"input",staticClass:"input",class:{
          error: _vm.error,
          disabled: _vm.disabledState || _vm.disabled,
          'input-hidden': !_vm.value && !_vm.isFocused && _vm.error,
          'not-empty': _vm.value || _vm.isFocused,
        },attrs:{"data-test-id":_vm.testId,"name":_vm.id,"disabled":_vm.disabledState,"maxlength":_vm.maxLength,"placeholder":_vm.placeholder,"type":_vm.type,"autocomplete":_vm.disableAutofill ? 'new-password' : ''},domProps:{"value":_vm.value},on:{"focus":_vm.onFocus,"blur":_vm.onBlur,"input":_vm.onInput,"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onEnter.apply(null, arguments)}}}),_vm._v(" "),(_vm.error)?_c('InputError',{staticClass:"input-error",attrs:{"error":_vm.error}}):_vm._e()],1),_vm._v(" "),(_vm.$slots.append)?_c('div',{staticClass:"input-append",on:{"mouseup":_vm.onPrependClick}},[_vm._t("append")],2):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }